import {
  FETCH_VENDORS,
  FETCH_VENDOR,
  SET_VENDOR_DELETE_CONFIRM
} from "../actions/Vendors";

const initialState = {
  cache: {},
  detail: {},
  deleteVendorIdConfirm: { showModal: false, sampleId: null }
};

export default function tags(state = initialState, action) {
  switch (action.type) {
    case FETCH_VENDORS:
      return { ...state, cache: action.payload };
    case FETCH_VENDOR:
      return { ...state, detail: action.payload };

    case SET_VENDOR_DELETE_CONFIRM:
      return {
        ...state,
        deleteVendorIdConfirm: {
          showModal: action.showModal,
          vendorId: action.vendorId
        }
      };

    default:
      return state;
  }
}
